/**
 * Examples page (e.g. examples/flowchart-software)
 **/

import throttle from 'lodash/throttle'
import fadeAnimation from '../modules/fadeAnimation'
import quotesCarousel from '../modules/quotesCarousel'
import getElementPosition from '../components/getElementPosition'
import { breakpoints, screenwidth } from '../utils'

const isJapanese = document.querySelector('html').getAttribute('lang') === 'ja'

if (!isJapanese && document.body.classList.contains('page--templates-inner')) {
  document.addEventListener('DOMContentLoaded', (e) => {

    // the "customerQuotes" JSON data is passed directly from the backend, and attached to the `window` object. Here, we grab it and make it accessible in our JS via "quoteData" object
    const quoteData = window.Cacoo.SiteResources.QuoteData.customerQuotes
      ? window.Cacoo.SiteResources.QuoteData.customerQuotes
      : []
    const qc = new quotesCarousel(quoteData)

    // Set up fade animations
    const animatedElements = document.querySelectorAll('.animated')
    new fadeAnimation(animatedElements)

    // Initialize quote carousel
    const quoteCarousel = document.querySelector('.js_quotes-carousel-section')

    // Get the position of the carousel currently on the page so we can set up the trigger point
    const carouselPosition = getElementPosition(quoteCarousel).top

    // The value below was chosen based on testing
    const heroAnimationTrigger = 750

    // Cache the hero container element
    const heroContainer = document.querySelector('.examples-hero__container')

    const slickSettings = {
      dots: true,
      draggable: true,
      arrows: false,
      autoplay: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: 'unslick',
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    }

    $(heroContainer).not('.slick-initialized').slick(slickSettings)

    // Current scroll position determines at which point the hero animation plays,
    // ..as well as when the quoteCarousel begins auto-rotating
    window.addEventListener(
      'scroll',

      // Throttle the number of times that detectElementsInViewport can fire (every 50ms)
      throttle((e) => {
        // Comparison point for the current scroll position (vertically)
        const currentScrollPoint = window.scrollY + $(window).height() * 0.9

        // Begin autoRotationOfQuotes when user scrolls to the quotes position
        if (
          !quoteCarousel.classList.contains('autorotate-started') &&
          currentScrollPoint > carouselPosition
        ) {
          qc.autoRotateQuotes()
          quoteCarousel.classList.add('autorotate-started')
        }

        // Trigger hero animation
        if (
          currentScrollPoint > heroAnimationTrigger &&
          screenwidth() >= breakpoints.MD
        ) {
          heroContainer.classList.add('active')
        }
      }, 50),
    )

    // reslick only if it's not slick()
    $(window).on('resize', function() {
      if ($(window).width() <= breakpoints.MD) {
        $(heroContainer).not('.slick-initialized').slick(slickSettings)
      }
    })
  })
}
